import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'round',
    standalone: false
})
export class RoundPipe implements PipeTransform {

  transform(value: number, places: number = 2): string {
    if(value !== null && typeof value !== 'undefined'){
      return parseFloat(value.toString()).toFixed(places);
    }
    return null;
  }

}
